/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncInstrumentLinkRegion} from '../api'

export const useMutationSyncInstrumentLinkRegion = createReactQueryMutationHook('syncInstrumentLinkRegion', syncInstrumentLinkRegion)
